export default __webpack_public_path__ + "static/media/EMPTY-DASH-BG-compressed.1eddd61b.png";